import { Component } from '@angular/core';
import { AuthService } from '@authentication/auth.service';
import { TipoUsuario } from '@shared/enums/tipoUsuario';

@Component({
  selector: 'app-configuraciones-index',
  templateUrl: './configuraciones-index.component.html',
  styleUrls: ['./configuraciones-index.component.scss']
})
export class ConfiguracionesIndexComponent {

  TipoUsuario = TipoUsuario;
  
  constructor(
    private authService: AuthService
  ) { }

  hasRole(...roles: TipoUsuario[]) {
    return this.authService.hasRole(...roles);
  }

}
